
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as ExtensionIconComponent } from "./extension-icon.svg";

export const ExtensionIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <ExtensionIconComponent {...props} />;
};
